import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ElementErrorUI = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "element-error-ui" */ './element-error-ui'),
	),
});
